import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import {
  FaPlus,
  FaTimesCircle,
  FaAngleDown,
  FaPaperclip,
  FaHeart,
  FaPrint,
  FaTimes,
  FaHistory,
  FaFile,
  FaBookmark,
} from 'react-icons/fa';
import { Button as ButtonPrime } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import Grid from '@material-ui/core/Grid';
import { Dialog as DialogPrime } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { InputText } from 'primereact/inputtext';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { isMobile } from 'react-device-detect';
import { Tooltip } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { Toast } from 'primereact/toast';
import Anotacao from './Anotacao';
import ImpressaoRPH from './ImpressaoRPH';
import ImpressaoPedidoInternacao from './ImpressaoPedidoInternacao';
import ImpressaoAvisoCirurgia from './ImpressaoAvisoCirurgia';
import ImpressaoSolicitacaoAIHIdentificacaoPaciente from './ImpressaoSolicitacaoAIHIdentificacaoPaciente';
import ImpressaoSolicitacaoAIHJustificativaInternacao from './ImpressaoSolicitacaoAIHJustificativaInternacao';
import ImpressaoSolicitacaoAIHProcedimentoSolicitado from './ImpressaoSolicitacaoAIHProcedimentoSolicitado';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'assets/scss/prime-table.scss';
import 'assets/css/prime-table.css';
import 'assets/css/documentos.css';
import 'assets/css/geral.css';
import 'assets/css/meus-pedidos.css';
import {
  getConfiguracoes,
  iniciaPilhaPendencias,
  PendenciasWizard,
  setPendencia,
} from '../Wizard/ValidacaoWizard';
import { tema } from '../../util';
import { dominioDemandaCirurgica, dominioNODE, dominioOperaAspNet } from '../../config/database';
import Axios from 'axios';

class MeusPedidos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pedidosCirurgia: [],
      listaProcedimento: [],
      listaStatus: [],
      procedimentoSelecionado: null,
      statusSelecionado: null,
      loading: false,
      redireciona: false,
      selectedDateInclusao: null,
      selectedDateSugerida: null,
      abreHistorico: false,
      listaHistoricoPedido: [],
      listaDocumentos: [],
      pedidoSelecionado: null,
      abreAnexoDocumento: false,
      profissional: null,
      anchorEl: null,
      listaFavoritoProfissional: [],
      listaFavoritoEquipe: [],
      listaModeloPedidoCirurgia: [],
      abreFavoritar: false,
      checkFavoritoProfissional: false,
      checkFavoritoEquipe: false,
      descricaoFavorito: '',
      globalFilter: null,
      abreConfirmacaoCancelacaoPedido: false,
      first: 0,
      abreMensagemErro: false,
      mensagemErro: '',
      abreAnotacoes: false,
      abreImpressaoRPH: false,
      abreImpressaoPedidoInternacao: false,
      equipeRequisitante: null,
      paciente: null,
      objetoPedidoSelecionado: null,
      abreAvisoCirurgia: false,
      mostraImpressoesFinalizado: false,
      mostraImpressoesAnestesia: false,
      idLegadoInternacao: null,
      bloqueioRecursoSistemaImpressaoPedidoInternacao: false,
      listaMotivosCancelamento: [],
      motivoCancelamentoSelecionado: null,
      observacoesCancelamento: null,
      abreImpressaoSolicitacaoAIH: false,
      pedidoCampanha: false,
      passoDadosAIH: 0,
      tipoPedidoPadrao: 0,
      modalCodigoPedido: false,
      codigoPedidoBusca: null,
      cancelRequest: null,
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    const profissional = JSON.parse(localStorage.getItem('profissional'));
    this.setState({ profissional });

    dominioDemandaCirurgica.get('/api/procedimentoCirurgico').then(response => {
      this.setState({ listaProcedimento: response.data.map(proc => proc.descricao) });
    });

    dominioDemandaCirurgica.get('/api/statusPedido').then(response => {
      this.setState({ listaStatus: response.data.map(status => status.descricao) });
    });

    dominioDemandaCirurgica.get('/api/motivoCancelamento').then(response => {
      this.setState({ listaMotivosCancelamento: response.data });
    });

    this.listarPedidosCirurgia();
    this.listarFavoritos();
    this.listarModelosPedidoCirurgia();
  }

  listarPedidosCirurgia = () => {
    if (this.state.cancelRequest) this.state.cancelRequest.cancel();

    const cancelRequest = Axios.CancelToken.source();
    this.setState({ cancelRequest, loading: true });

    const profissional = JSON.parse(localStorage.getItem('profissional'));

    let url = '';

    if (this.state.codigoPedidoBusca)
      url = `/api/pedidoCirurgiaMedico/${profissional.profissional_id}?codigo=${this.state.codigoPedidoBusca}`;
    else
      url = `/api/pedidoCirurgiaMedico/${profissional.profissional_id}`;

    dominioDemandaCirurgica.get(url, { cancelToken: cancelRequest.token }).then(
      res => {
        this.setState({
          pedidosCirurgia: res.data,
          loading: false,
        });
      },
      () => {
        this.setState({ loading: false });
      }
    );
  };

  listarFavoritos = () => {
    const profissional = JSON.parse(localStorage.getItem('profissional'));

    dominioDemandaCirurgica
      .get(`/api/pedidoCirurgiasFavoritasProfissional/${profissional.profissional_id}`)
      .then(response => {
        this.setState({ listaFavoritoProfissional: response.data });
      });

    dominioDemandaCirurgica
      .get(`/api/pedidoCirurgiasFavoritasEquipe/${profissional.equipe_id}`)
      .then(response => {
        this.setState({ listaFavoritoEquipe: response.data });
      });
  };

  listarModelosPedidoCirurgia = () => {
    const profissional = JSON.parse(localStorage.getItem('profissional'));

    dominioDemandaCirurgica
      .get(`/api/modeloPedidoCirurgiaPorEquipe/${profissional.equipe_id}`)
      .then(response => {
        this.setState({ listaModeloPedidoCirurgia: response.data });
      });
  };

  handleRelatorioPedido = id => {
    dominioDemandaCirurgica().then(promise => {
      window.open(`${promise.config.baseURL}/resumoPedido/${id}`);
    });
  };

  handleAvisoCirurgia = () => {
    this.setState({ abreAvisoCirurgia: true });
  };

  handleAbreAnotacoes = id => {
    this.setState({
      pedidoSelecionado: id,
      abreAnotacoes: true,
    });
  };

  handlePedidoInternacao = pedido => {
    dominioDemandaCirurgica().then(promise => {
      window.open(`${promise.config.baseURL}/pedidoInternacao/${pedido}`);
    });
  };

  handleSolicitacaoAIH = pedido => {
    if (this.state.objetoPedidoSelecionado.dataImpressaoAIH) {
      dominioDemandaCirurgica().then(promise => {
        window.open(`${promise.config.baseURL}/solicitacaoAIH/${pedido}`);
      });
      return;
    }

    localStorage.removeItem('solicitacaoAIH');

    this.setState({
      abreImpressaoSolicitacaoAIH: true,
    });
  };

  closeDialogAvisoCirurgia = () => {
    this.setState({ abreAvisoCirurgia: false });
  };

  closeDialogPedidoInternacao = () => {
    this.setState({ abreImpressaoPedidoInternacao: false });
  };

  closeDialogRPH = () => {
    this.setState({ abreImpressaoRPH: false });
  };

  handlePedidoProdutosHemoterapicos = pedido => {
    if (this.state.objetoPedidoSelecionado.dataImpressaoRPH) {
      // this.showWarn('A Requisição de produtos hemoterápicos já foi impressa!', 'warn');
      dominioDemandaCirurgica().then(promise => {
        window.open(`${promise.config.baseURL}/hemoterapicos/${pedido}`);
      });
      return;
    }

    this.setState({
      abreImpressaoRPH: true,
      anchorMenuImpressao: false,
    });
  };

  handleEncaminhamentoAvaliacaoPreAnestesia = pedido => {
    dominioDemandaCirurgica().then(promise => {
      window.open(`${promise.config.baseURL}/encaminhamentoAvaliacaoPreAnestesia/${pedido}`);
    });
  };

  setAbreImpressaoRPH = value => {
    this.setState({
      abreImpressaoRPH: value,
    });
  };

  handleImpressaoTodos = id => {
    this.handleAvisoCirurgia(id);
    this.handlePedidoInternacao(id);
    this.handlePedidoProdutosHemoterapicos(id);
  };

  alterarPassoDadosAIH = passo => {
    this.setState({
      passoDadosAIH: passo,
    });
  };

  handleDadosSolicitacaoAIH = () => {
    if (this.state.passoDadosAIH === 0)
      return (
        <ImpressaoSolicitacaoAIHIdentificacaoPaciente
          alterarPassoDadosAIH={this.alterarPassoDadosAIH}
          idLegadoPaciente={this.state.objetoPedidoSelecionado?.idLegadoPaciente}
        />
      );
    if (this.state.passoDadosAIH === 1) {
      const solicitacaoAIH = JSON.parse(localStorage.getItem('solicitacaoAIH'));
      if (!solicitacaoAIH.cidPrincipal)
        solicitacaoAIH.cidPrincipal = this.state.objetoPedidoSelecionado.cidPrincipal;
      if (!solicitacaoAIH.diagnosticoInicial)
        solicitacaoAIH.diagnosticoInicial = this.state.objetoPedidoSelecionado.cidPrincipal.descricao;

      localStorage.setItem('solicitacaoAIH', JSON.stringify(solicitacaoAIH));

      return (
        <ImpressaoSolicitacaoAIHJustificativaInternacao
          alterarPassoDadosAIH={this.alterarPassoDadosAIH}
        />
      );
    }
    if (this.state.passoDadosAIH === 2) {
      const solicitacaoAIH = JSON.parse(localStorage.getItem('solicitacaoAIH'));
      if (!solicitacaoAIH.descricaoProcedimentoSolicitado)
        solicitacaoAIH.descricaoProcedimentoSolicitado = this.state.objetoPedidoSelecionado.procedimento;
      if (!solicitacaoAIH.codigoProcedimento)
        solicitacaoAIH.codigoProcedimento = this.state.objetoPedidoSelecionado.codigoProcedimento;
      if (!solicitacaoAIH.clinica)
        solicitacaoAIH.clinica = this.state.objetoPedidoSelecionado.equipeRequisitante;
      if (!solicitacaoAIH.caraterInternacao)
        solicitacaoAIH.caraterInternacao = this.state.objetoPedidoSelecionado.caraterAtendimento;
      if (!solicitacaoAIH.documento) solicitacaoAIH.documento = 'CPF';
      if (!solicitacaoAIH.numeroDocumentoProfissional)
        solicitacaoAIH.numeroDocumentoProfissional = this.state.objetoPedidoSelecionado.cpfProfissional;
      if (!solicitacaoAIH.nomeProfissional)
        solicitacaoAIH.nomeProfissional = this.state.objetoPedidoSelecionado.profissionalRequisitante;
      if (!solicitacaoAIH.pedidoCirurgia)
        solicitacaoAIH.pedidoCirurgia = this.state.objetoPedidoSelecionado.id;

      localStorage.setItem('solicitacaoAIH', JSON.stringify(solicitacaoAIH));

      return (
        <ImpressaoSolicitacaoAIHProcedimentoSolicitado
          alterarPassoDadosAIH={this.alterarPassoDadosAIH}
          handleFechaSolicitacaoAIH={this.handleFechaSolicitacaoAIH}
          listarPedidosCirurgia={this.listarPedidosCirurgia}
        />
      );
    }
    return <></>;
  };

  //  DAQUI PRA BAIXO SÃO AS FUNÇOES DE CONTROLE DA TABELA
  codigoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Código</span>
        <span>{rowData.codigo}</span>
      </>
    );
  };

  pacienteBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Paciente</span>
        <div>
          {rowData.GMR === 'True' && <small className="sinalizacao-gmr">GMR</small>}
          {rowData.eOncologica === '1' && <small className="sinalizacao-oncologica">ONCO</small>}
        </div>
        <span>{rowData.paciente}</span>
      </>
    );
  };

  procedimentoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Procedimento</span>
        <span>{rowData.procedimento}</span>
      </>
    );
  };

  statusBodyTemplate = rowData => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <span className="bolinha-status" style={{ backgroundColor: rowData.corStatus }} />
        <span style={{ marginLeft: '20px' }}>{rowData.status}</span>
      </div>
    );
  };

  dataInclusaoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Data Solicitada</span>
        <span>
          {new Date(rowData.dataInclusao).toLocaleString([], {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </span>
      </>
    );
  };

  dataCirurgiaBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Data Sugerida</span>
        <span>
          {rowData.dataCirurgia != null
            ? new Date(rowData.dataCirurgia).toLocaleString([], {
                day: '2-digit',
                month: '2-digit',
                year: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              })
            : null}
        </span>
      </>
    );
  };

  acoesBodyTemplate = rowData => {
    return (
      <div>
        <span className="p-column-title">Ações</span>
        {/* <Tooltip title="Anexar Documentos">
          <IconButton
            onClick={() => this.handleAbreDocumento(rowData.id)}
            disabled={rowData.status.toUpperCase() === 'CANCELADO'}
            color="inherit"
            style={{
              marginRight: '1px',
              backgroundColor:
                rowData.status.toUpperCase() === 'CANCELADO' ? 'lightgray' : tema.normal,
              color: 'white',
            }}
          >
            <FaPaperclip size={15} />
          </IconButton>
          </Tooltip> */}
        <Tooltip title="Favoritar">
          <IconButton
            onClick={() => this.handleAbreFavoritar(rowData.id)}
            disabled={rowData.status.toUpperCase() === 'CANCELADO'}
            color="inherit"
            style={{
              marginRight: '2px',
              backgroundColor:
                rowData.status.toUpperCase() === 'CANCELADO' ? 'lightgray' : tema.morno,
              color: 'white',
            }}
          >
            <FaHeart size={15} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Resumo">
          <IconButton
            className={`${
              rowData.status.toUpperCase() === 'CANCELADO' ? 'button-invisible' : null
            }`}
            color="inherit"
            style={{ marginRight: '2px', backgroundColor: tema.frio, color: 'white' }}
            onClick={() => this.handleRelatorioPedido(rowData.id)}
          >
            <FaFile size={15} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Cancelar">
          <IconButton
            disabled={rowData.status.toUpperCase() === 'CANCELADO'}
            color="inherit"
            style={{
              marginRight: '2px',
              backgroundColor:
                rowData.status.toUpperCase() === 'CANCELADO' ? 'lightgray' : tema.quente,
              color: 'white',
            }}
            onClick={() =>
              this.setState({
                abreConfirmacaoCancelacaoPedido: true,
                pedidoSelecionado: rowData.id,
              })
            }
          >
            <FaTimes size={15} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Ver histórico">
          <IconButton
            color="inherit"
            style={{ marginRight: '2px', backgroundColor: tema.gelado, color: 'white' }}
            onClick={() => this.handleAbreHistorico(rowData.id)}
          >
            <FaHistory size={15} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Impressão">
          <IconButton
            className={`${
              rowData.status.toUpperCase() === 'FINALIZADO' ||
              rowData.necessariaAvaliacaoAnestesica ||
              rowData.possuiHemoterapico
                ? null
                : 'button-invisible'
            }`}
            color="inherit"
            style={{
              marginRight: '2px',
              color: 'white',
              backgroundColor: tema.fervendo,
            }}
            onClick={event => {
              this.handleClickPopMenuImpressao(event, rowData, rowData.paciente_idLegado);
            }}
          >
            <FaPrint size={15} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Anotações">
          <IconButton
            color="inherit"
            style={{
              marginRight: '2px',
              color: 'white',
              backgroundColor: tema.antartida,
            }}
            onClick={() => this.handleAbreAnotacoes(rowData.id)}
          >
            <FaBookmark size={15} />
          </IconButton>
        </Tooltip>
      </div>
    );
  };

  formatDate = date => {
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month < 10) {
      month = `0${month}`;
    }

    if (day < 10) {
      day = `0${day}`;
    }

    return `${date.getFullYear()}-${month}-${day}`;
  };

  filterDate = (value, filter) => {
    if (
      filter === undefined ||
      filter === null ||
      (typeof filter === 'string' && filter.trim() === '')
    ) {
      return true;
    }

    if (value === undefined || value === null) {
      return false;
    }

    return value === this.formatDate(filter);
  };

  procedimentoItemTemplate = option => {
    return <span className={`customer-badge status-${option}`}>{option}</span>;
  };

  statusItemTemplate = option => {
    return <span className={`customer-badge status-${option}`}>{option}</span>;
  };

  handleFechaHistorico = () => {
    this.setState({ abreHistorico: false });
  };

  handleAbreHistorico = id => {
    this.consultaHistoricoPedido(id);
    this.setState({
      abreHistorico: true,
      pedidoSelecionado: id,
    });
  };

  consultaHistoricoPedido(id_pedido) {
    dominioNODE.get(`logpedido/${id_pedido}`).then(res => {
      this.setState({
        listaHistoricoPedido: res.data,
      });
    });
  }

  handleFechaDocumento = () => {
    this.setState({ abreAnexoDocumento: false });
  };

  handleAbreDocumento = id => {
    this.consultaDocumento(id);
    this.setState({
      abreAnexoDocumento: true,
      pedidoSelecionado: id,
    });
  };

  onSelectDocumento = e => {
    if (e.files[0].size > 5000000) {
      this.setState({
        abreMensagemErro: true,
        mensagemErro: 'Tamanho de arquivo excedeu o tamanho máximo (5MB)',
      });
      return;
    }

    const dataDocumento = new FormData();

    dataDocumento.append('arquivo', e.files[0], e.files[0].name);
    dataDocumento.append('pedidoCirurgia', this.state.pedidoSelecionado);

    dominioDemandaCirurgica.post(`/api/documento`, dataDocumento).then(res => {
      const lista = [...this.state.listaDocumentos, res.data];
      this.setState({ listaDocumentos: lista });
    });
  };

  getSplitNomeDocumento = nome => {
    const nomeSplit = nome.split('/');
    return nomeSplit[nomeSplit.length - 1];
  };

  handleExcluirDocumento = id => {
    dominioDemandaCirurgica.delete(`/api/documentodetail/${id}`).then(() => {
      this.consultaDocumento(this.state.pedidoSelecionado);
    });
  };

  consultaDocumento(id_pedido) {
    dominioDemandaCirurgica.get(`/api/documento/${id_pedido}`).then(
      res => {
        this.setState({ listaDocumentos: res.data, loading: false });
      },
      () => {}
    );
  }

  handleCancelarPedidoCirurgia = id => {
    if (!this.state.motivoCancelamentoSelecionado) {
      this.showWarn('É necessário informar o motivo de cancelamento!', 'warn');
      return;
    }

    const dadosCancelamento = {
      motivoCancelamentoSelecionadoId: this.state.motivoCancelamentoSelecionado.id,
      observacoesCancelamento: this.state.observacoesCancelamento,
    };

    dominioDemandaCirurgica.put(`/api/cancelarPedidoCirurgia/${id}`, dadosCancelamento).then(
      () => {
        const dataLog = {
          id_usuario: this.state.profissional.userid,
          username:
            this.state.profissional.username === undefined
              ? 'naologado'
              : this.state.profissional.username,
          id_pedido: id,
          tipo: 'Status',
          descricao: 'CANCELADO',
        };

        dominioNODE.post('/logpedido', dataLog).catch(error => {
          console.log(`ERRO AO INCLUIR LOG: ${error}`);
        });
        this.setState({
          abreConfirmacaoCancelacaoPedido: false,
          motivoCancelamentoSelecionado: null,
          observacoesCancelamento: null,
        });
        this.listarPedidosCirurgia();
      },
      err => {
        this.showWarn(`${err}`, 'warn');
      }
    );
  };

  handleClickPopMenuFavoritos = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClosePopMenuFavoritos = () => {
    this.setState({ anchorEl: null });
  };

  handleClickPopMenuImpressao = (event, rowData, paciente) => {
    const configuracoesRecursoSistema = JSON.parse(
      localStorage.getItem('configuracoesRecursoSistema')
    );

    let bloqueioImpressaoPedidoInternacao = false;

    if (rowData.modalidadeAtendimento)
      bloqueioImpressaoPedidoInternacao = rowData.modalidadeAtendimento.recursosBloqueados.some(
        recursoBloqueado =>
          recursoBloqueado.id === configuracoesRecursoSistema.impressaoPedidoInternacao
      );

    this.setState({
      anchorMenuImpressao: event.currentTarget,
      pedidoSelecionado: rowData.id,
      idLegadoInternacao: rowData.idLegadoInternacao,
      paciente,
      objetoPedidoSelecionado: rowData,
      mostraImpressoesFinalizado: rowData.status.toUpperCase() === 'FINALIZADO',
      bloqueioRecursoSistemaImpressaoPedidoInternacao: bloqueioImpressaoPedidoInternacao,
      mostraImpressoesAnestesia: rowData.necessariaAvaliacaoAnestesica,
      mostraImpressaoHemoterapico: rowData.possuiHemoterapico,
      pedidoCampanha: rowData.pedidoCampanha,
    });
  };

  handleClosePopMenuImpressao = () => {
    this.setState({ anchorMenuImpressao: null });
  };

  limparLocalStorage = () => {
    localStorage.setItem('activeStep', '0');
    localStorage.removeItem('convenio');
    localStorage.removeItem('peso');
    localStorage.removeItem('completed');
    localStorage.removeItem('paciente');
    localStorage.removeItem('dadosSolicitacao');
    localStorage.removeItem('faa');
    localStorage.removeItem('atendimento');
    localStorage.removeItem('data_atendimento');
    localStorage.removeItem('seq_atendimento');
    localStorage.removeItem('carater');
    localStorage.removeItem('dataSugerida');
    localStorage.removeItem('centroCirurgico');
    localStorage.removeItem('lateralidade');
    localStorage.removeItem('indicacaoClinica');
    localStorage.removeItem('prioridade');
    localStorage.removeItem('cidPrincipal');
    localStorage.removeItem('cidsSecundarios');
    localStorage.removeItem('tipoAcomodacao');
    localStorage.removeItem('diariasPrevistas');
    localStorage.removeItem('leitoUTI');
    localStorage.removeItem('tipoAnestesia');
    localStorage.removeItem('caixasOPME');
    localStorage.removeItem('materiaisConsumiveis');
    localStorage.removeItem('caixasCirurgicas');
    localStorage.removeItem('hemoderivados');
    localStorage.removeItem('procedimentoPrincipal');
    localStorage.removeItem('procedimentosSecundarios');
    localStorage.removeItem('documentos');
    localStorage.removeItem('pedidoCirurgia');
    localStorage.removeItem('equipamentos');
    localStorage.removeItem('equipeRequisitante');
    localStorage.removeItem('duracaoEstimada');
    localStorage.removeItem('pendenciasPaciente');
    localStorage.removeItem('pendenciasDatas');
    localStorage.removeItem('pendenciasCirurgia');
    localStorage.removeItem('pendenciasSolicitacao');
    localStorage.removeItem('telefone');
    localStorage.removeItem('email');
    localStorage.removeItem('idPedidoCirurgia');
    localStorage.removeItem('celular');
    localStorage.removeItem('pendenciasSolicitacao');
    localStorage.removeItem('exames');
    localStorage.removeItem('dataInternacao');
    localStorage.removeItem('motivoAntecipacaoInternacao');
    localStorage.removeItem('avaliacaoAnestesica');
    localStorage.removeItem('motivoAvaliacaoAnestesica');
    localStorage.removeItem('internacao');
    localStorage.removeItem('modalidadeAtendimento');
    localStorage.removeItem('novoPaciente');
    localStorage.removeItem('tipoPedido');
    localStorage.removeItem('centroCirurgicoPermitido');
    localStorage.removeItem('caraterAtendimentoPermitido');
    localStorage.removeItem('lateralidadePermitida');
    localStorage.removeItem('cidPrincipalPermitido');
    localStorage.removeItem('cidSecundarioPermitido');
    localStorage.removeItem('tipoAcomodacaoPermitido');
    localStorage.removeItem('motivoAntecipacaoPermitido');
    localStorage.removeItem('tipoAnestesiaPadrao');
    localStorage.removeItem('procedimentoPrincipalPermitido');
    localStorage.removeItem('procedimentoSecundarioPermitido');
    localStorage.removeItem('caixaOPMEPermitida');
    localStorage.removeItem('materialConsumivelPermitido');
    localStorage.removeItem('caixaCirurgicaPermitida');
    localStorage.removeItem('hemocomponentePermitido');
    localStorage.removeItem('equipamentoPermitido');
    localStorage.removeItem('pedidoCirurgiaVemDoModelo');
    localStorage.removeItem('salaCirurgia');
    localStorage.removeItem('aprovacaoAutomatica');
    localStorage.removeItem('slaModelo');
    localStorage.removeItem('idModeloPedidoCirurgia');
    localStorage.removeItem('demandaId');
    localStorage.removeItem('listaModalidadeAtendimento');
    localStorage.removeItem('temAtendimento');
    localStorage.removeItem('principaisSinaisSintomas');
    localStorage.removeItem('principaisResultadosProvasDiagnosticas');
    localStorage.removeItem('recursosNecessariosAtendimentoPaciente');
    localStorage.removeItem('historiaClinica');
    localStorage.removeItem('areaMedica');
    localStorage.removeItem('profissionalResponsavel');
  };

  handleNovoPedido = () => {
    this.limparLocalStorage();
    localStorage.setItem('tipoPedido', this.state.tipoPedidoPadrao);
    iniciaPilhaPendencias();
    getConfiguracoes();
    this.setState({ redireciona: true });
  };

  handleFechaFavoritar = () => {
    this.setState({ abreFavoritar: false });
  };

  handleAbreFavoritar = id => {
    this.setState({
      abreFavoritar: true,
      pedidoSelecionado: id,
    });
  };

  handleFavoritar = () => {
    const dataFavoritar = {
      idProfissional: this.state.checkFavoritoProfissional
        ? this.state.profissional.profissional_id
        : null,
      idPedidoCirurgia: this.state.pedidoSelecionado,
      descricao: this.state.descricaoFavorito,
      idEquipe: this.state.checkFavoritoEquipe ? this.state.profissional.equipe_id : null,
    };

    dominioDemandaCirurgica.post('/api/favoritarPedidoCirurgia', dataFavoritar).then(
      () => {
        this.setState({ checkFavoritoEquipe: false, checkFavoritoProfissional: false });
        this.handleFechaFavoritar();
        this.listarFavoritos();
        this.listarPedidosCirurgia();
      },
      () => {}
    );
  };

  async handleNovoPedidoPorFavorito(id) {
    this.limparLocalStorage();
    iniciaPilhaPendencias();
    getConfiguracoes();

    const dataFavorito = {
      idProfissional: this.state.profissional.profissional_id,
      idPedidoCirurgiaFavorito: id,
    };

    let pedidoCirurgia = {};

    const [
      responseCaixasOPME,
      responsecaixasMaterial,
      responseCaixasCirurgicas,
      responseHemoderivados,
      responseEquipamentos,
    ] = await Promise.all([
      dominioDemandaCirurgica.get(`/api/itemCaixaOPMEPedidoFavorito/${id}`),
      dominioDemandaCirurgica.get(`/api/itemMaterialConsumivelPedidoFavorito/${id}`),
      dominioDemandaCirurgica.get(`/api/itemCaixaCirurgicaPedidoFavorito/${id}`),
      dominioDemandaCirurgica.get(`/api/itemHemoderivadosPedidoFavorito/${id}`),
      dominioDemandaCirurgica.get(`/api/itemEquipamentoPedidoFavorito/${id}`),
    ]);

    dominioDemandaCirurgica
      .post('/api/incluirPedidoCirurgiaPorPedidoFavorito', dataFavorito)
      .then(
        response => {
          pedidoCirurgia = response.data;
        },
        () => {
          console.log('ERRO AO INCLUIR COM FAVORITO');
        }
      )
      .then(() => {
        const cidsSecundarios = pedidoCirurgia.cidSecundario;
        const prioridade = pedidoCirurgia.prioridadeCirurgia;
        const procedimentosSecundarios = pedidoCirurgia.procedimentoSecundario;
        const {
          centroCirurgico,
          lateralidade,
          cidPrincipal,
          tipoAnestesia,
          procedimentoPrincipal,
          modalidadeAtendimento,
        } = pedidoCirurgia;
        const caixasOPME = [];
        const materialConsumivel = [];
        const caixasCirurgicas = [];
        const hemoderivados = [];
        const equipamentos = [];

        let lista = [];

        lista = responseCaixasOPME.data;
        lista.forEach(caixa =>
          caixasOPME.push({
            id: caixa.item.id,
            idLegado: caixa.item.idLegado,
            codigo: caixa.item.codigo,
            descricao: caixa.item.descricao,
            tipoItem: caixa.item.tipoItem,
            quantidade: caixa.quantidade,
            itemEventual: caixa.itemEventual,
            justificativaEventual: caixa.justificativaEventual,
          })
        );

        lista = responsecaixasMaterial.data;
        lista.forEach(material =>
          materialConsumivel.push({
            id: material.item.id,
            idLegado: material.item.idLegado,
            codigo: material.item.codigo,
            descricao: material.item.descricao,
            tipoItem: material.item.tipoItem,
            quantidade: material.quantidade,
            itemEventual: material.itemEventual,
            justificativaEventual: material.justificativaEventual,
          })
        );

        lista = responseCaixasCirurgicas.data;
        lista.forEach(caixa =>
          caixasCirurgicas.push({
            id: caixa.item.id,
            idLegado: caixa.item.idLegado,
            codigo: caixa.item.codigo,
            descricao: caixa.item.descricao,
            tipoItem: caixa.item.tipoItem,
            quantidade: caixa.quantidade,
          })
        );

        lista = responseHemoderivados.data;
        lista.forEach(hemoderivado =>
          hemoderivados.push({
            id: hemoderivado.item.id,
            idLegado: hemoderivado.item.idLegado,
            codigo: hemoderivado.item.codigo,
            descricao: hemoderivado.item.descricao,
            tipoItem: hemoderivado.item.tipoItem,
            quantidade: hemoderivado.quantidade,
            unidadeMedida: hemoderivado.unidadeMedida,
          })
        );

        lista = responseEquipamentos.data;
        lista.forEach(equipamento =>
          equipamentos.push({
            id: equipamento.item.id,
            idLegado: equipamento.item.idLegado,
            codigo: equipamento.item.codigo,
            descricao: equipamento.item.descricao,
            tipoItem: equipamento.item.tipoItem,
            quantidade: equipamento.quantidade,
          })
        );

        //  const lisProcedimentos = procedimentosSecundarios.map(item => item.procedimento);

        localStorage.setItem('cidsSecundarios', JSON.stringify(cidsSecundarios));
        localStorage.setItem('prioridade', JSON.stringify(prioridade));
        localStorage.setItem(
          'procedimentosSecundarios',
          JSON.stringify(
            procedimentosSecundarios.map(item => {
              const { procedimento } = item;
              procedimento.quantidade = item.quantidade;
              return procedimento;
            })
          )
        );
        localStorage.setItem('centroCirurgico', JSON.stringify(centroCirurgico));
        localStorage.setItem('modalidadeAtendimento', JSON.stringify(modalidadeAtendimento));
        localStorage.setItem('lateralidade', lateralidade);
        localStorage.setItem('cidPrincipal', JSON.stringify(cidPrincipal));
        localStorage.setItem('tipoAnestesia', JSON.stringify(tipoAnestesia));
        procedimentoPrincipal.quantidade = pedidoCirurgia.quantidadeProcedimentoPrincipal;
        localStorage.setItem('procedimentoPrincipal', JSON.stringify(procedimentoPrincipal));
        localStorage.setItem('duracaoEstimada', procedimentoPrincipal.duracao);
        localStorage.setItem('caixasOPME', JSON.stringify(caixasOPME));
        localStorage.setItem('materiaisConsumiveis', JSON.stringify(materialConsumivel));
        localStorage.setItem('caixasCirurgicas', JSON.stringify(caixasCirurgicas));
        localStorage.setItem('hemoderivados', JSON.stringify(hemoderivados));
        localStorage.setItem('equipamentos', JSON.stringify(equipamentos));

        this.setState({ redireciona: true });
      });
  }

  async handleNovoPedidoPorModeloPedidoCirurgia(idModeloPedidoCirurgia) {
    this.limparLocalStorage();
    iniciaPilhaPendencias();
    getConfiguracoes();

    localStorage.setItem('pedidoCirurgiaVemDoModelo', JSON.stringify(true));

    const [responseModeloPedidoCirurgia] = await Promise.all([
      dominioDemandaCirurgica.get(`/api/modeloPedidoCirurgia/${idModeloPedidoCirurgia}`),
    ]);

    const dadosModelo = responseModeloPedidoCirurgia.data;

    const centroCirurgico = dadosModelo.centroCirurgicoPadrao;
    const caraterAtendimento = dadosModelo.caraterAtendimentoPadrao;

    localStorage.setItem('centroCirurgico', JSON.stringify(dadosModelo.centroCirurgicoPadrao));
    localStorage.setItem('carater', JSON.stringify(dadosModelo.caraterAtendimentoPadrao));

    if (centroCirurgico && caraterAtendimento) {
      dominioDemandaCirurgica
        .get(
          `/api/modalidadesCentroCirurgicoCaraterAtendimento/${caraterAtendimento.id}/${centroCirurgico.id}`
        )
        .then(response => {
          localStorage.setItem('listaModalidadeAtendimento', JSON.stringify(response.data));
          localStorage.setItem('modalidadeAtendimento', JSON.stringify(response.data[0]));
          setPendencia(1, PendenciasWizard.modalidadeAtendimento);
        });
    }
    localStorage.setItem('idModeloPedidoCirurgia', idModeloPedidoCirurgia);
    localStorage.setItem('lateralidade', dadosModelo.lateralidadePadrao);
    setPendencia(1, PendenciasWizard.lateralidade);
    localStorage.setItem('cidPrincipal', JSON.stringify(dadosModelo.cidPrincipalPadrao));
    localStorage.setItem('cidsSecundarios', JSON.stringify(dadosModelo.cidSecundarioPadrao));
    localStorage.setItem('tipoAcomodacao', JSON.stringify(dadosModelo.tipoAcomodacaoPadrao));
    localStorage.setItem(
      'motivoAntecipacaoInternacao',
      JSON.stringify(dadosModelo.motivoAntecipacaoPadrao)
    );
    localStorage.setItem('tipoAnestesia', JSON.stringify(dadosModelo.tipoAnestesiaPadrao));
    localStorage.setItem('leitoUTI', JSON.stringify(dadosModelo.necessitaLeito));
    localStorage.setItem(
      'duracaoEstimadaMinimaPermitida',
      JSON.stringify(dadosModelo.duracaoEstimadaMinima)
    );
    localStorage.setItem(
      'duracaoEstimadaMaximaPermitida',
      JSON.stringify(dadosModelo.duracaoEstimadaMaxima)
    );
    localStorage.setItem(
      'diariasPrevistasMinima',
      JSON.stringify(dadosModelo.diariasPrevistasMinima)
    );
    localStorage.setItem(
      'diariasPrevistasMaxima',
      JSON.stringify(dadosModelo.diariasPrevistasMaxima)
    );
    localStorage.setItem(
      'centroCirurgicoPermitido',
      JSON.stringify(dadosModelo.centroCirurgicoPermitido)
    );
    localStorage.setItem(
      'caraterAtendimentoPermitido',
      JSON.stringify(dadosModelo.caraterAtendimentoPermitido)
    );
    localStorage.setItem(
      'lateralidadePermitida',
      JSON.stringify(dadosModelo.lateralidadePermitida)
    );
    localStorage.setItem(
      'cidPrincipalPermitido',
      JSON.stringify(dadosModelo.cidPrincipalPermitido)
    );
    localStorage.setItem(
      'cidSecundarioPermitido',
      JSON.stringify(dadosModelo.cidSecundarioPermitido)
    );
    localStorage.setItem(
      'tipoAcomodacaoPermitido',
      JSON.stringify(dadosModelo.tipoAcomodacaoPermitido)
    );
    localStorage.setItem(
      'motivoAntecipacaoPermitido',
      JSON.stringify(dadosModelo.motivoAntecipacaoPermitido)
    );
    localStorage.setItem(
      'tipoAnestesiaPermitido',
      JSON.stringify(dadosModelo.tipoAnestesiaPermitido)
    );
    localStorage.setItem(
      'procedimentoPrincipalPermitido',
      JSON.stringify(dadosModelo.procedimentoPrincipalPermitido)
    );
    localStorage.setItem(
      'procedimentoSecundarioPermitido',
      JSON.stringify(dadosModelo.procedimentoSecundarioPermitido)
    );
    localStorage.setItem('caixaOPMEPermitida', JSON.stringify(dadosModelo.caixaOPMEPermitida));
    localStorage.setItem(
      'materialConsumivelPermitido',
      JSON.stringify(dadosModelo.materialConsumivelPermitido)
    );
    localStorage.setItem(
      'caixaCirurgicaPermitida',
      JSON.stringify(dadosModelo.caixaCirurgicaPermitida)
    );
    localStorage.setItem(
      'hemocomponentePermitido',
      JSON.stringify(dadosModelo.hemocomponentePermitido)
    );
    localStorage.setItem('equipamentoPermitido', JSON.stringify(dadosModelo.equipamentoPermitido));
    localStorage.setItem('slaModelo', JSON.stringify(dadosModelo.SLA));
    localStorage.setItem(
      'perspectivaValidacaoDosDiasModelo',
      JSON.stringify(dadosModelo.perspectivaValidacaoDosDias)
    );
    localStorage.setItem('aprovacaoAutomatica', JSON.stringify(dadosModelo.aprovacaoAutomatica));

    if (dadosModelo.procedimentoPrincipalPadrao) {
      const { procedimentoPrincipalPadrao } = dadosModelo;
      procedimentoPrincipalPadrao.quantidade = dadosModelo.quantidadeProcedimentoPrincipalPadrao;

      localStorage.setItem('procedimentoPrincipal', JSON.stringify(procedimentoPrincipalPadrao));
      localStorage.setItem('duracaoEstimada', dadosModelo.procedimentoPrincipalPadrao.duracao);
    }

    const procedimentoSecundarioPadrao = [];
    dadosModelo.procedimentoSecundarioPadraoModeloPedido.forEach(procedimentoSecundario => {
      procedimentoSecundarioPadrao.push({
        id: procedimentoSecundario.procedimento.id,
        idLegado: procedimentoSecundario.procedimento.idLegado,
        codigo: procedimentoSecundario.procedimento.codigo,
        descricao: procedimentoSecundario.procedimento.descricao,
        tempo: procedimentoSecundario.procedimento.tempo,
        quantidade: procedimentoSecundario.quantidade,
      });
    });
    localStorage.setItem('procedimentosSecundarios', JSON.stringify(procedimentoSecundarioPadrao));

    const caixasOPME = [];
    dadosModelo.caixaOPMEPadraoModeloPedido.forEach(caixa => {
      caixasOPME.push({
        id: caixa.item.id,
        idLegado: caixa.item.idLegado,
        codigo: caixa.item.codigo,
        descricao: caixa.item.descricao,
        tipoItem: caixa.item.tipoItem,
        quantidade: caixa.quantidade,
        unidadeMedida: caixa.unidadeMedida,
        itemEventual: caixa.itemEventual,
        justificativaEventual: caixa.justificativaEventual,
      });
    });
    localStorage.setItem('caixasOPME', JSON.stringify(caixasOPME));

    const materiaisConsumiveis = [];
    dadosModelo.materialConsumivelPadraoModeloPedido.forEach(material => {
      materiaisConsumiveis.push({
        id: material.item.id,
        idLegado: material.item.idLegado,
        codigo: material.item.codigo,
        descricao: material.item.descricao,
        tipoItem: material.item.tipoItem,
        quantidade: material.quantidade,
        unidadeMedida: material.unidadeMedida,
      });
    });
    localStorage.setItem('materiaisConsumiveis', JSON.stringify(materiaisConsumiveis));

    const caixasCirurgicas = [];
    dadosModelo.caixaCirurgicaPadraoModeloPedido.forEach(caixaCirurgica => {
      caixasCirurgicas.push({
        id: caixaCirurgica.item.id,
        idLegado: caixaCirurgica.item.idLegado,
        codigo: caixaCirurgica.item.codigo,
        descricao: caixaCirurgica.item.descricao,
        tipoItem: caixaCirurgica.item.tipoItem,
        quantidade: caixaCirurgica.quantidade,
        unidadeMedida: caixaCirurgica.unidadeMedida,
      });
    });
    localStorage.setItem('caixasCirurgicas', JSON.stringify(caixasCirurgicas));

    const hemoderivados = [];
    dadosModelo.hemocomponentePadraoModeloPedido.forEach(hemocomponente => {
      hemoderivados.push({
        id: hemocomponente.item.id,
        idLegado: hemocomponente.item.idLegado,
        codigo: hemocomponente.item.codigo,
        descricao: hemocomponente.item.descricao,
        tipoItem: hemocomponente.item.tipoItem,
        quantidade: hemocomponente.quantidade,
        unidadeMedida: hemocomponente.unidadeMedida,
      });
    });
    localStorage.setItem('hemoderivados', JSON.stringify(hemoderivados));

    const equipamentos = [];
    dadosModelo.equipamentoPadraoModeloPedido.forEach(equipamento => {
      equipamentos.push({
        id: equipamento.item.id,
        idLegado: equipamento.item.idLegado,
        codigo: equipamento.item.codigo,
        descricao: equipamento.item.descricao,
        tipoItem: equipamento.item.tipoItem,
        quantidade: equipamento.quantidade,
        unidadeMedida: equipamento.unidadeMedida,
      });
    });
    localStorage.setItem('equipamentos', JSON.stringify(equipamentos));

    this.setState({ redireciona: true });
  }

  renderFooterDisplay = () => {
    return (
      <div>
        <ButtonPrime
          label="Não"
          icon="pi pi-times"
          onClick={() => this.setState({ abreConfirmacaoCancelacaoPedido: false })}
          className="p-button-text"
        />
        <ButtonPrime
          label="Sim"
          icon="pi pi-check"
          onClick={() => this.handleCancelarPedidoCirurgia(this.state.pedidoSelecionado)}
          autoFocus
        />
      </div>
    );
  };

  renderFooterModalCodigoPedido = () => {
    return (
      <div>
        <ButtonPrime
          label="Continuar"
          icon="pi pi-check"
          onClick={() =>
            this.setState({ modalCodigoPedido: false }, () => this.listarPedidosCirurgia())
          }
          autoFocus
        />
      </div>
    );
  };

  renderFooterDisplayErro = () => {
    return (
      <div>
        <ButtonPrime
          label="OK"
          icon="pi pi-check"
          onClick={() => this.setState({ abreMensagemErro: false })}
          autoFocus
        />
      </div>
    );
  };

  handleFechaSolicitacaoAIH = () => {
    localStorage.removeItem('solicitacaoAIH');
    this.setState({ abreImpressaoSolicitacaoAIH: false, passoDadosAIH: 0 });
  };

  showWarn(msg, severity) {
    this.toast.show({
      severity,
      summary: 'Atenção!',
      detail: msg,
      life: 3000,
    });
  }

  render() {
    const pt = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
      dayNamesMin: ['DO', 'SE', 'TE', 'QA', 'QI', 'SX', 'SA'],
      monthNames: [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
      ],
      monthNamesShort: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez',
      ],
      today: 'Hoje',
      clear: 'Limpar',
      dateFormat: 'dd/mm/yy',
      weekHeader: 'Sm',
    };

    // const representativeFilter = <MultiSelect value={this.state.selectedRepresentative} options={this.representatives} itemTemplate={this.representativesItemTemplate} onChange={(e) => this.setState({ selectedRepresentative: e.value })} optionLabel="name" optionValue="name" placeholder="All" className="p-column-filter" />;
    const dateInclusaoFilter = (
      <Calendar
        locale={pt}
        value={this.state.selectedDateInclusao}
        onChange={e => {
          this.setState({ selectedDateInclusao: e.value });
          if (e.value === null) {
            this.dt.filter(null, 'dataInclusao', 'notEquals');
            return;
          }
          this.dt.filter(
            new Date(e.value).toISOString().substring(0, 10),
            'dataInclusao',
            'startsWith'
          );
        }}
        dateFormat="dd/mm/yy"
        className="p-column-filter"
        placeholder="Data"
        showButtonBar
      />
    );

    const dateCirurgiaFilter = (
      <Calendar
        locale={pt}
        value={this.state.selectedDateSugerida}
        onChange={e => {
          this.setState({ selectedDateSugerida: e.value });
          if (e.value === null) {
            this.dt.filter(null, 'dataInclusao', 'notEquals');
            return;
          }
          this.dt.filter(
            new Date(e.value).toISOString().substring(0, 10),
            'dataCirurgia',
            'startsWith'
          );
        }}
        dateFormat="dd/mm/yy"
        className="p-column-filter"
        placeholder="Data"
        showButtonBar
      />
    );

    const procedimentosFilter = (
      <Autocomplete
        id="filtroProcedimento"
        options={this.state.listaProcedimento}
        getOptionLabel={option => `${option}`}
        onChange={(e, value) => {
          this.setState({ procedimentoSelecionado: value });
          this.dt.filter(value, 'procedimento', 'equals');
        }}
        value={this.state.procedimentoSelecionado}
        filterSelectedOptions
        renderInput={params => <TextField {...params} label="Procedimento" variant="outlined" />}
      />
    );

    const statusFilter = (
      <Autocomplete
        options={this.state.listaStatus}
        getOptionLabel={option => `${option}`}
        onChange={(e, value) => {
          this.setState({ statusSelecionado: value });
          this.dt.filter(value, 'status', 'equals');
        }}
        value={this.state.statusSelecionado}
        filterSelectedOptions
        renderInput={params => <TextField {...params} label="Status" variant="outlined" />}
      />
    );

    if (this.state.redireciona) {
      return <Redirect from="/admin" to="/admin/wizard" />;
    }

    const header = (
      <>
        <div className="table-header campo-filtro">
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={e => this.setState({ globalFilter: e.target.value })}
              placeholder="Pesquise pela descrição dos campos..."
              style={{ width: '78vw', height: '6vh' }}
            />
          </span>
        </div>
      </>
    );

    return (
      <div id="laranja">
        <DialogPrime
          header="Buscar pedido pelo código"
          visible={this.state.modalCodigoPedido}
          style={{ width: '40vw' }}
          onHide={() => this.setState({ modalCodigoPedido: false })}
          footer={this.renderFooterModalCodigoPedido()}
        >
          <TextField
            style={{ marginBottom: '20px', marginTop: '10px' }}
            id="codigoPedido"
            label="Informe o código do pedido"
            variant="outlined"
            fullWidth
            onChange={e => this.setState({ codigoPedidoBusca: e.target.value })}
          />
        </DialogPrime>
        <DialogPrime
          header="Impressão da RPH"
          visible={this.state.abreImpressaoRPH}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreImpressaoRPH: false })}
        >
          <>
            <ImpressaoRPH
              pedido={this.state.pedidoSelecionado}
              closeDialog={this.closeDialogRPH}
              listarPedidosCirurgia={this.listarPedidosCirurgia}
            />
          </>
        </DialogPrime>
        <DialogPrime
          header="Histórico do pedido"
          visible={this.state.abreHistorico}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreHistorico: false })}
        >
          <div>
            {/* <center>
              <strong>{`Histórico pedido ${this.state.pedidoSelecionado}`}</strong>
            </center> */}
            <ul>
              {this.state.listaHistoricoPedido.map(log => (
                <li key={log.id}>
                  <strong>{format(parseISO(log.createdAt), 'dd/MM/yy HH:mm')}</strong>
                  <p>{`${log.tipo} --> ${log.descricao}`}</p>
                  Usuário:
                  {log.username}
                </li>
              ))}
            </ul>
          </div>
        </DialogPrime>
        <DialogPrime
          header="Documentos"
          visible={this.state.abreAnexoDocumento}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreAnexoDocumento: false })}
        >
          <div>
            <div className="card">
              <FileUpload
                className="esconder-botoes-upload-cancelar"
                name="demo[]"
                onSelect={this.onSelectDocumento}
                multiple
                previewWidth={10}
                maxFileSize={1000000}
                chooseLabel="Escolher"
                cancelLabel="Cancelar"
              />
            </div>
            <div id="content" className="div-content">
              {this.state.listaDocumentos.map(item => {
                return (
                  <div key={item.id} style={{ width: '100%', marginBottom: '5px' }}>
                    <span>{this.getSplitNomeDocumento(item.arquivo)}</span>
                    <span>
                      <button
                        type="button"
                        className="botao-excluir-documento"
                        onClick={() => this.handleExcluirDocumento(item.id)}
                      >
                        <FaTimesCircle color="black" size={20} />
                      </button>
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </DialogPrime>
        <DialogPrime
          header="Favoritar pedido"
          visible={this.state.abreFavoritar}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreFavoritar: false })}
        >
          <div>
            <TextField
              style={{ marginBottom: '20px', marginTop: '10px' }}
              id="descFavoritar"
              label="Descrição"
              variant="outlined"
              fullWidth
              onChange={e => this.setState({ descricaoFavorito: e.target.value })}
            />
            <div style={{ marginBottom: '20px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="checkedA"
                    checked={this.state.checkFavoritoProfissional}
                    onChange={e => this.setState({ checkFavoritoProfissional: e.target.checked })}
                  />
                }
                label="Para mim"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="checkedB"
                    checked={this.state.checkFavoritoEquipe}
                    onChange={e => this.setState({ checkFavoritoEquipe: e.target.checked })}
                  />
                }
                label="Para minha equipe"
              />
            </div>
            <div style={{ float: 'right' }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={this.handleFavoritar}
                disabled={!this.state.checkFavoritoProfissional && !this.state.checkFavoritoEquipe}
              >
                Favoritar
              </Button>
            </div>
          </div>
        </DialogPrime>
        <DialogPrime
          header="Cancelar pedido"
          visible={this.state.abreConfirmacaoCancelacaoPedido}
          style={{ width: '65vw' }}
          footer={this.renderFooterDisplay()}
          onHide={() => this.setState({ abreConfirmacaoCancelacaoPedido: false })}
        >
          <div>
            <Container className="container-dialog-cancelar-pedido">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Autocomplete
                    id="listaMotivosCancelamento"
                    options={this.state.listaMotivosCancelamento}
                    getOptionLabel={option => `${option.descricao}`}
                    onChange={(e, value) => {
                      this.setState({ motivoCancelamentoSelecionado: value });
                    }}
                    value={this.state.motivoCancelamentoSelecionado}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Motivo para Cancelamento"
                        variant="outlined"
                        fullWidth
                        required
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    multiline
                    rows={5}
                    rowsMax={15}
                    name="observacoesCancelamento"
                    variant="outlined"
                    fullWidth
                    id="observacoesCancelamento"
                    label="Observações"
                    value={this.state.observacoesCancelamento}
                    onChange={e => this.setState({ observacoesCancelamento: e.target.value })}
                    inputProps={{
                      maxlength: 500,
                    }}
                    InputLabelProps={{ shrink: true }}
                    className="observacoesCancelamento"
                  />
                </Grid>
              </Grid>
            </Container>
          </div>
        </DialogPrime>
        <DialogPrime
          header="Atenção!"
          visible={this.state.abreMensagemErro}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreMensagemErro: false })}
          footer={this.renderFooterDisplayErro()}
        >
          <div>
            <p>{this.state.mensagemErro}</p>
          </div>
        </DialogPrime>
        <DialogPrime
          header="Anotações"
          className="dialog-anotacao"
          id="dialog-anotacao"
          visible={this.state.abreAnotacoes}
          style={{ width: '85vw' }}
          onHide={() => this.setState({ abreAnotacoes: false })}
        >
          <>
            <Anotacao pedidoCirurgia={this.state.pedidoSelecionado} />
          </>
        </DialogPrime>
        <DialogPrime
          header="Impressão do Pedido de Internação"
          visible={this.state.abreImpressaoPedidoInternacao}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreImpressaoPedidoInternacao: false })}
        >
          <>
            <ImpressaoPedidoInternacao
              paciente={this.state.paciente}
              equipe={this.state.equipeRequisitante}
              pedido={this.state.pedidoSelecionado}
              closeDialog={this.closeDialogPedidoInternacao}
              listarPedidosCirurgia={this.listarPedidosCirurgia}
            />
          </>
        </DialogPrime>
        <DialogPrime
          header="Solicitação de AIH"
          visible={this.state.abreImpressaoSolicitacaoAIH}
          style={{ width: '65vw' }}
          onHide={this.handleFechaSolicitacaoAIH}
        >
          {this.handleDadosSolicitacaoAIH()}
        </DialogPrime>
        <DialogPrime
          header="Impressão do Aviso de Cirurgia"
          visible={this.state.abreAvisoCirurgia}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreAvisoCirurgia: false })}
        >
          <>
            <ImpressaoAvisoCirurgia
              pedido={this.state.objetoPedidoSelecionado}
              closeDialog={this.closeDialogAvisoCirurgia}
              listarPedidosCirurgia={this.listarPedidosCirurgia}
            />
          </>
        </DialogPrime>
        <Toast
          ref={el => {
            this.toast = el;
          }}
          position="top-right"
        />
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <br />
            <Card>
              <CardHeader color="rose" id="centroMeusPedidos" className="card-header">
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <p className="card-title">
                      <strong>Meus Pedidos</strong>
                    </p>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      aria-controls="menu-favoritos"
                      aria-haspopup="true"
                      onClick={this.handleClickPopMenuFavoritos}
                      style={{
                        float: 'right',
                        backgroundColor: 'white',
                        borderTopLeftRadius: '0px',
                        borderBottomLeftRadius: '0px',
                        height: '100%',
                      }}
                      className="botao-favoritos"
                    >
                      <FaAngleDown color="rgb(50, 66, 140)" size={24} />
                    </Button>
                    <Button
                      onClick={this.handleNovoPedido}
                      style={{
                        float: 'right',
                        backgroundColor: 'white',
                        color: 'rgb(50, 66, 140)',
                        borderTopRightRadius: '0px',
                        borderBottomRightRadius: '0px',
                      }}
                      className="botao-novo-pedido"
                      startIcon={<FaPlus color="rgb(50, 66, 140)" size={22} />}
                    >
                      Novo
                    </Button>
                    <Button
                      onClick={() => this.setState({ modalCodigoPedido: true, codigoPedidoBusca: null })}
                      style={{
                        float: 'right',
                        backgroundColor: 'white',
                        color: 'rgb(50, 66, 140)',
                        marginRight: '15px',
                      }}
                    >
                      Buscar pedido pelo código
                    </Button>
                    <Menu
                      id="menu-favoritos"
                      anchorEl={this.state.anchorEl}
                      keepMounted
                      open={Boolean(this.state.anchorEl)}
                      onClose={this.handleClosePopMenuFavoritos}
                      MenuListProps={{
                        style: { width: isMobile ? '60vw' : '20vw', padding: '0px' },
                      }}
                    >
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography>Favoritos</Typography>
                        </AccordionSummary>
                        {this.state.listaFavoritoProfissional.length > 0 ? (
                          <div>
                            <span className="menu-header">Meus favoritos</span>
                            {this.state.listaFavoritoProfissional.map(fav => (
                              <MenuItem
                                style={{ borderBottom: 'solid #e7e7e7 1px' }}
                                key={fav.id}
                                onClick={() => this.handleNovoPedidoPorFavorito(fav.id)}
                              >
                                {fav.descricao}
                              </MenuItem>
                            ))}
                          </div>
                        ) : (
                          <div style={{ marginLeft: '5px' }}>Sem registros de favoritos</div>
                        )}
                        {this.state.listaFavoritoEquipe.length > 0 ? (
                          <div>
                            <span className="menu-header">Favoritos da equipe</span>
                            {this.state.listaFavoritoEquipe.map(fav => (
                              <MenuItem
                                style={{ borderBottom: 'solid #e7e7e7 1px' }}
                                key={fav.id}
                                onClick={() => this.handleNovoPedidoPorFavorito(fav.id)}
                              >
                                {fav.descricao}
                              </MenuItem>
                            ))}
                          </div>
                        ) : null}
                      </Accordion>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography>Modelos de Pedido de Cirurgia</Typography>
                        </AccordionSummary>
                        {this.state.listaModeloPedidoCirurgia.length > 0 ? (
                          <div>
                            {/* <span className="menu-header">Meus favoritos</span> */}
                            {this.state.listaModeloPedidoCirurgia.map(modelo => (
                              <MenuItem
                                style={{ borderBottom: 'solid #e7e7e7 1px' }}
                                key={modelo.id}
                                onClick={() =>
                                  this.handleNovoPedidoPorModeloPedidoCirurgia(modelo.id)
                                }
                              >
                                {modelo.nomeModeloPedidoCirurgia}
                              </MenuItem>
                            ))}
                          </div>
                        ) : (
                          <div style={{ marginLeft: '5px' }}>
                            Sem registros de modelo de pedido de cirurgia.
                          </div>
                        )}
                      </Accordion>
                    </Menu>
                    <Menu
                      id="menu-impressao"
                      anchorEl={this.state.anchorMenuImpressao}
                      keepMounted
                      open={Boolean(this.state.anchorMenuImpressao)}
                      onClose={this.handleClosePopMenuImpressao}
                      MenuListProps={{ style: { width: isMobile ? '60vw' : '20vw' } }}
                    >
                      <MenuItem
                        style={{
                          borderBottom: 'solid #e7e7e7 1px',
                          display: this.state.mostraImpressoesFinalizado ? '' : 'none',
                        }}
                        onClick={() => this.handleAvisoCirurgia()}
                      >
                        Aviso de Cirurgia
                      </MenuItem>
                      <MenuItem
                        style={{
                          borderBottom: 'solid #e7e7e7 1px',
                          display:
                            this.state.mostraImpressoesFinalizado &&
                            !this.state.bloqueioRecursoSistemaImpressaoPedidoInternacao
                              ? ''
                              : 'none',
                        }}
                        onClick={() => {
                          this.handlePedidoInternacao(this.state.pedidoSelecionado);
                        }}
                        disabled={this.state.idLegadoInternacao}
                      >
                        Pedido de Internação
                      </MenuItem>
                      <MenuItem
                        style={{
                          borderBottom: 'solid #e7e7e7 1px',
                          display: this.state.pedidoCampanha ? '' : 'none',
                        }}
                        onClick={() => {
                          this.handleSolicitacaoAIH(this.state.pedidoSelecionado);
                        }}
                      >
                        Solicitação de AIH
                      </MenuItem>
                      <MenuItem
                        style={{
                          borderBottom: 'solid #e7e7e7 1px',
                          display: this.state.mostraImpressaoHemoterapico ? '' : 'none',
                        }}
                        onClick={() => {
                          this.handlePedidoProdutosHemoterapicos(this.state.pedidoSelecionado);
                        }}
                      >
                        Produtos Hemoterápicos
                      </MenuItem>
                      <MenuItem
                        style={{
                          borderBottom: 'solid #e7e7e7 1px',
                          display: this.state.mostraImpressoesAnestesia ? '' : 'none',
                        }}
                        onClick={() => {
                          this.handleEncaminhamentoAvaliacaoPreAnestesia(
                            this.state.pedidoSelecionado
                          );
                        }}
                      >
                        Encaminhamento Avaliação Pré-Anestesia
                      </MenuItem>
                    </Menu>
                  </Grid>
                </Grid>
              </CardHeader>
              <CardBody className="card-body-0-padding">
                <div className="datatable">
                  <div className="card">
                    <DataTable
                      ref={el => (this.dt = el)}
                      value={this.state.pedidosCirurgia}
                      paginator
                      header={header}
                      globalFilter={this.state.globalFilter}
                      rows={10}
                      className="p-datatable-prime"
                      emptyMessage="Sem pedidos"
                      loading={this.state.loading}
                      first={this.state.first}
                      onPage={e => {
                        this.setState({ first: e.first });
                        document.location.href = `${document.location.href.replace(
                          '#centroMeusPedidos',
                          ''
                        )}#centroMeusPedidos`;
                      }}
                    >
                      <Column
                        field="codigo"
                        header="Nº pedido"
                        sortable
                        body={this.codigoBodyTemplate}
                        filter
                        filterPlaceholder="Nº pedido"
                        filterMatchMode="contains"
                        headerStyle={{ width: '10vw' }}
                      />
                      <Column
                        field="paciente"
                        header="Paciente"
                        sortable
                        body={this.pacienteBodyTemplate}
                        filter
                        filterPlaceholder="Nome"
                        filterMatchMode="contains"
                        headerStyle={{ width: '10vw' }}
                      />
                      <Column
                        field="procedimento"
                        header="Procedimento principal"
                        sortable
                        body={this.procedimentoBodyTemplate}
                        filter
                        filterElement={procedimentosFilter}
                        headerStyle={{ width: '15vw' }}
                      />
                      <Column
                        field="dataInclusao"
                        header="Data Solicitação"
                        sortable
                        body={this.dataInclusaoBodyTemplate}
                        filter
                        filterElement={dateInclusaoFilter}
                        filterFunction={() => this.filterDate()}
                        headerStyle={{ width: '10vw' }}
                      />
                      <Column
                        field="dataCirurgia"
                        header="Data Cirurgia"
                        sortable
                        body={this.dataCirurgiaBodyTemplate}
                        filter
                        filterElement={dateCirurgiaFilter}
                        filterFunction={this.filterDate}
                        headerStyle={{ width: '10vw' }}
                      />
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        body={this.statusBodyTemplate}
                        filter
                        filterElement={statusFilter}
                        headerStyle={{ width: '10vw' }}
                      />
                      <Column header="Ações" body={this.acoesBodyTemplate} />
                    </DataTable>
                  </div>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default MeusPedidos;
